export default function getParams(pathname: string) {
  const firstRange = pathname.indexOf("/");
  const secondRange = pathname.indexOf("/", firstRange + 1);

  return pathname.slice(secondRange + 1);
}
